import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkType',
})
export class CheckTypePipe implements PipeTransform {

  transform<VALUE, VALUEARR, CONTROL extends VALUEARR>(
    object: VALUE, valueInArray: VALUEARR, controlValue: CONTROL): VALUE {
    return object;
  }
}
